var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Component } from 'react';
import style from './ToggleEntry.css';
var ToggleEntry = /** @class */ (function (_super) {
    __extends(ToggleEntry, _super);
    function ToggleEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = "";
        _this.getCheckBoxId = function () {
            if (!_this.id) {
                _this.id = _this.props.id || '__checkbox_' + (++ToggleEntry.idCounter);
            }
            return _this.id;
        };
        _this.onClick = function (e) {
            e.preventDefault();
            var active = !_this.props.active;
            if (_this.props.onChange) {
                _this.props.onChange(active);
            }
        };
        return _this;
    }
    ToggleEntry.prototype.render = function () {
        return (React.createElement("li", { className: style.toggleEntry },
            React.createElement("a", { onClick: this.onClick },
                React.createElement("input", { id: this.getCheckBoxId(), type: "checkbox", checked: this.props.active, className: "checkbox", readOnly: true }),
                React.createElement("label", { htmlFor: this.getCheckBoxId() }, this.props.children))));
    };
    ToggleEntry.idCounter = 0;
    return ToggleEntry;
}(Component));
export { ToggleEntry };
